<template>
    <div class="modal fade" :class="{'z-index-apply' : showBranch}" id="rider_modal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="myModalLabel">Add / Update Rider: {{rider.name}}</h4>
                </div>
                <form method="post" @submit.prevent="updateRider()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="name">Name</label>
                            <input v-model="rider.name" type="text" :disabled="showBranch" required="required" class="form-control" id="name" placeholder="Name...">
                        </div>
                        <div class="form-group">
                            <label >Contact</label>
                            <input v-model="rider.contact" pattern="^03\d{9}|\+?\d{11}$" :disabled="rider.id>0" type="text" required="required" class="form-control" placeholder="03xxxxxxxxx">
                        </div>
                        <div class="form-group">
                            <label>Vehicle Number</label>
                            <input v-model="rider.vehicleNumber" @input="rider.vehicleNumber=$event.target.value.toUpperCase()" required="required" :disabled="showBranch" type="text" class="form-control" placeholder="Vehicle No...">
                        </div>
                        <div class="form-group" v-if="showBranch">
                            <label>Restaurant <i class="text-danger text-sm" v-if="!selectedRestaurant"> *Requried</i></label>
                            <multiselect :disabled="isBranchUser || isRoleUser" v-model="selectedRestaurant" :hideSelected="true" :options="restaurants" label="name" track-by="name" @input="fetchBranchesOfRestaurant()"></multiselect>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
                                    <div class="sk-bounce1"></div>
                                    <div class="sk-bounce2"></div>
                                    <div class="sk-bounce3"></div>
                                </div>
                            </div>
                        </div>
                            <div class="form-group" v-if="showBranch">
                                <label>Branches<i class="text-danger text-sm" v-if="!selectedBranch"> *Requried</i></label>
                                <multiselect :disabled="isBranchUser" v-model="selectedBranch" :hideSelected="true" :options="branches" :custom-label="opt=> opt.areasByAreaId.name" track-by="id"></multiselect>
                            </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-primary" :disabled="!selectedBranch && showBranch">Save</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

</template>

<script>
    /* eslint-disable */
    import Multiselect from 'vue-multiselect'
    import {addBranchToRider, getAllRiderBranches, addUpdateRider} from "@/api/riders";

    export default {
      components: {Multiselect},
      name: "AddUpdateRider",
      data: function () {
        return {
          rider: {
            "id": 0,
            "name": "",
            "contact": null,
            "vehicleNumber": "",
          },
          selectedRestaurant: null,
          selectedBranch: null,
          loggedInRole: "",
          isHideSpinner: "hide",
          restaurants: [],
          branches: [],
          email: '',
          showBranch: false,
          applyZindex: true,
        };
      },
      computed: {
        isBranchUser() {
          return this.$store.state.user.userRolesById[0].role === 'ROLE_BRANCH'
        },
        isRoleUser() {
          return this.$store.state.user.userRolesById[0].role === 'ROLE_USER'
        }
      },
      watch: {
        rider: {
          handler(val) {
            this.rider = val
          },
          deep: true
        },
      },
      mounted: function () {
        let user = this.$store.state.user;
        this.loggedInRole = this.$store.state.user;
        let role = user.userRolesById[0].role;
        if (this.showBranch) {
          this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
            this.restaurants = resp.data;
          });
        }
      },
      methods: {
        load: function (riderId, showBranch) {
          this.selectedRestaurant = null;
          if (this.isRoleUser) {
            this.selectedRestaurant = this.$store.state.user.restaurant;
            this.fetchBranchesOfRestaurant()
          }
          this.selectedBranch = null;
          this.branches = [];
          this.showBranch = showBranch
          if (riderId > 0) {
            this.$http.get(this.$store.state.mainAppURL + "riders/get_rider_detail", {params: {rider_id: riderId}}).then(resp => {
              this.rider = resp.data;
            }).catch(ex => {
              this.showErrorMessage(ex);
            });
          } else {
            this.resetData();
          }
          if (this.showBranch) {
            this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
              this.restaurants = resp.data;
            });
          }
            setTimeout(() => {
              $("#rider_modal").modal("show");
              $("#rider_modal").focus()
            }, 500);
        },
        fetchBranchesOfRestaurant: function () {
          this.isHideSpinner = "";
          let params = new URLSearchParams();
          params.append("restaurant_id", this.selectedRestaurant.id);
          this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_branches", params).then(resp => {
            this.isHideSpinner = "hide";
            this.branches = resp.data;
          });
        },
        updateRider: function () {
          Swal.fire({
            title: 'Please Wait! We are processing the data.',
            type: 'info',
            allowOutsideClick: false,
            allowEscapeKey: false,
            onBeforeOpen: () => {
              Swal.showLoading();
            },
          });
          let formData = new FormData();
          if (!this.showBranch) {
            this.addUpdateRiderInfo(formData)
          } else {
            this.assignBranch(formData)
          }
        },
        async addUpdateRiderInfo(formData) {
          try {
            formData.append("rider", JSON.stringify(this.rider));
            await addUpdateRider(formData);
            Swal.close();
            this.$parent.tableDraw();
            $("#rider_modal").modal("hide");
            if (this.rider.id === 0) {
              swal("SUCCESS!", "Rider has been added successfully!", "success");
            } else {
              swal("SUCCESS!", "Rider has been updated successfully!", "success");
            }
            this.resetData();
          } catch (ex) {
            this.showErrorMessage(ex)
          }
        },
        async assignBranch(formData) {
          try {
            let riderId = JSON.stringify(this.rider.id)
            formData.append("rider_id", riderId);
            formData.append("branch_id", this.selectedBranch.id);
            await addBranchToRider(formData);
            Swal.close();
            $("#rider_modal").modal("hide");
            await this.$parent.$refs.viewAddUpdateRiderBranchesRef.loadRiderBranches(riderId)
            swal("SUCCESS!", "Branch has been assigned successfully!", "success");
            this.$parent.tableDraw();
          } catch (ex) {
            $("#rider_modal").modal("hide");
            this.showErrorMessage(ex)
          }
        },
        resetData: function () {
          this.rider = {
            "id": 0,
            "name": "",
            "contact": null,
            "vehicleNumber": "",
          };
          this.selectedRestaurant = "";
          this.branches = [];
        },
      }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.z-index-apply { overflow: auto !important;
  z-index: 999999!important;
}

</style>
